<script>
import { toFormattedNumber } from '@/utils/number'

export default {
  props: {
    type: {
      type: String,
      default: ''
    },

    amount: {
      type: Number,
      default: 0
    },

    user: {
      type: String,
      default: ''
    }
  },

  computed: {
    prefix() {
      switch (this.type) {
        case 'extend':
          return {
            amount: 'ดอกเบี้ยที่รับชำระ',
            user: 'พนักงานต่อขายฝาก'
          }

        case 'redeem':
          return {
            amount: 'จำนวนเงินไถ่ถอน',
            user: 'พนักงานผู้รับไถ่ถอน'
          }

        case 'dispose':
          return {
            user: 'พนักงานตัดขายฝาก'
          }

        default:
          return null
      }
    }
  },

  render() {
    return (
      this.prefix && (
        <div>
          {this.amount !== null && (
            <div>
              {this.prefix.amount}:
              <span
                style={{
                  fontSize: '1.25rem',
                  fontWeight: 'bold',
                  marginLeft: '0.5rem'
                }}
              >
                {toFormattedNumber(this.amount, 2)}
              </span>
              <span style={{ marginLeft: '0.5rem' }}>บาท</span>
            </div>
          )}

          {this.$slots.default && (
            <div style={{ marginTop: '0.25rem' }}>{this.$slots.default}</div>
          )}

          {this.user !== null && (
            <div style={{ marginTop: '0.25rem' }}>
              {this.prefix.user}:
              <span style={{ marginLeft: '0.5rem' }}>{this.user}</span>
            </div>
          )}
        </div>
      )
    )
  }
}
</script>
